/**
 * Created by caterina on 04-05-17.
 */
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ProjectService} from './project.service';
import {WarehouseService} from './warehouse.service';
import {ProjectRoutingModule} from './project-routing.module';
import {ProjectComponent} from './project-view/project-view.component';
import {ProjectListComponent} from './project-list/project-list.component';
import {ProjectDataFormComponent} from './project-form-components/project-data-form/project-data-form.component';
import {WarehouseParamsFormDirective} from './project-form-components/warehouse-params-forms/warehouse-params-form.directive';
import {WarehouseParamsFormSelectorComponent} from './project-form-components/warehouse-params-forms/warehouse-params-form-selector/warehouse-params-form-selector.component';
import {WarehouseParamsFormService} from './project-form-components/warehouse-params-forms/warehouse-params-form.service';
import {Warehouse1ParamsFormComponent} from './project-form-components/warehouse-params-forms/warehouse1-params-form/warehouse1-params-form.component';
import {Warehouse2ParamsFormComponent} from './project-form-components/warehouse-params-forms/warehouse2-params-form/warehouse2-params-form.component';
import {Warehouse3ParamsFormComponent} from './project-form-components/warehouse-params-forms/warehouse3-params-form/warehouse3-params-form.component';
import {Warehouse4ParamsFormComponent} from './project-form-components/warehouse-params-forms/warehouse4-params-form/warehouse4-params-form.component';
import {Warehouse5ParamsFormComponent} from './project-form-components/warehouse-params-forms/warehouse5-params-form/warehouse5-params-form.component';
import {Warehouse6ParamsFormComponent} from './project-form-components/warehouse-params-forms/warehouse6-params-form/warehouse6-params-form.component';
import {Frame1Component} from '../sketch/frames/frame1.component';
import {Frame2Component} from '../sketch/frames/frame2.component';
import {Frame3Component} from '../sketch/frames/frame3.component';
import {Frame4Component} from '../sketch/frames/frame4.component';
import {Frame5Component} from '../sketch/frames/frame5.component';
import {Frame6Component} from '../sketch/frames/frame6.component';
import {LiningsAndLoadsComponent} from './project-form-components/linings-and-loads/linings-and-loads.component';
import {WarehouseProfilesFormDirective} from './project-form-components/warehouse-profiles-form/warehouse-profiles-form.directive';
import {WarehouseProfilesFormSelectorComponent} from 'app/project/project-form-components/warehouse-profiles-form/warehouse-profiles-form-selector/warehouse-profiles-form-selector.component';
import {Warehouse1ProfilesFormComponent} from './project-form-components/warehouse-profiles-form/warehouse1-profiles-form/warehouse1-profiles-form.component';
import {Warehouse2ProfilesFormComponent} from './project-form-components/warehouse-profiles-form/warehouse2-profiles-form/warehouse2-profiles-form.component';
import {Warehouse3ProfilesFormComponent} from './project-form-components/warehouse-profiles-form/warehouse3-profiles-form/warehouse3-profiles-form.component';
import {Warehouse4ProfilesFormComponent} from './project-form-components/warehouse-profiles-form/warehouse4-profiles-form/warehouse4-profiles-form.component';
import {Warehouse5ProfilesFormComponent} from './project-form-components/warehouse-profiles-form/warehouse5-profiles-form/warehouse5-profiles-form.component';
import {Warehouse6ProfilesFormComponent} from './project-form-components/warehouse-profiles-form/warehouse6-profiles-form/warehouse6-profiles-form.component';
import {FormInputComponent} from './project-form-components/warehouse-profiles-form/form-input-component/form-input.component';
import {LiningAndCoveringService} from './lining-and-covering.service';
import {Rebar1Component} from '../sketch/rebars/rebar1.component';
import {Rebar2Component} from '../sketch/rebars/rebar2.component';
import {Rebar3Component} from '../sketch/rebars/rebar3.component';
import {Rebar4Component} from '../sketch/rebars/rebar4.component';
import {Rebar5Component} from '../sketch/rebars/rebar5.component';
import {Rebar6Component} from '../sketch/rebars/rebar6.component';
import {WindColumn1Component} from '../sketch/wind-columns/wind-column1.component';
import {WindColumn2Component} from '../sketch/wind-columns/wind-column2.component';
import {WindColumn3Component} from '../sketch/wind-columns/wind-column3.component';
import {WindColumn4Component} from '../sketch/wind-columns/wind-column4.component';
import {WindColumn5Component} from '../sketch/wind-columns/wind-column5.component';
import {WindColumn6Component} from '../sketch/wind-columns/wind-column6.component';
import {Miniframe1Component} from '../sketch/miniframes/miniframe1.component';
import {Miniframe2Component} from '../sketch/miniframes/miniframe2.component';
import {Miniframe3Component} from '../sketch/miniframes/miniframe3.component';
import {Miniframe4Component} from '../sketch/miniframes/miniframe4.component';
import {Miniframe5Component} from '../sketch/miniframes/miniframe5.component';
import {Miniframe6Component} from '../sketch/miniframes/miniframe6.component';
import {RebarDetailComponent} from '../sketch/rebar-detail/rebar-detail.component';
import {DetailUf1Component} from '../sketch/detail-uf/detail-uf1.component';
import {DetailUf2Component} from '../sketch/detail-uf/detail-uf2.component';
import {DetailUf3Component} from '../sketch/detail-uf/detail-uf3.component';
import {DetailUf4Component} from '../sketch/detail-uf/detail-uf4.component';
import {DetailUf5Component} from '../sketch/detail-uf/detail-uf5.component';
import {DetailUf6Component} from '../sketch/detail-uf/detail-uf6.component';
import { SecondaryElementsComponent } from './project-form-components/secondary-elements/secondary-elements.component';
import { DownloadComponent } from './project-form-components/download/download.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ProjectRoutingModule,
        ReactiveFormsModule
    ],
    exports: [
        ProjectListComponent
    ],
    declarations: [
        ProjectComponent,
        ProjectListComponent,
        ProjectDataFormComponent,
        FormInputComponent,
        WarehouseParamsFormSelectorComponent,
        WarehouseParamsFormDirective,
        Warehouse1ParamsFormComponent,
        Warehouse2ParamsFormComponent,
        Warehouse3ParamsFormComponent,
        Warehouse4ParamsFormComponent,
        Warehouse5ParamsFormComponent,
        Warehouse6ParamsFormComponent,
        WarehouseProfilesFormSelectorComponent,
        WarehouseProfilesFormDirective,
        Warehouse1ProfilesFormComponent,
        Warehouse2ProfilesFormComponent,
        Warehouse3ProfilesFormComponent,
        Warehouse4ProfilesFormComponent,
        Warehouse5ProfilesFormComponent,
        Warehouse6ProfilesFormComponent,
        Frame1Component,
        Frame2Component,
        Frame3Component,
        Frame4Component,
        Frame5Component,
        Frame6Component,
        LiningsAndLoadsComponent,
        Rebar1Component,
        Rebar2Component,
        Rebar3Component,
        Rebar4Component,
        Rebar5Component,
        Rebar6Component,
        WindColumn1Component,
        WindColumn2Component,
        WindColumn3Component,
        WindColumn4Component,
        WindColumn5Component,
        WindColumn6Component,
        Miniframe1Component,
        Miniframe2Component,
        Miniframe3Component,
        Miniframe4Component,
        Miniframe5Component,
        Miniframe6Component,
        RebarDetailComponent,
        SecondaryElementsComponent,
        DetailUf1Component,
        DetailUf2Component,
        DetailUf3Component,
        DetailUf4Component,
        DetailUf5Component,
        DetailUf6Component,
        DownloadComponent,

    ],
    providers: [
        ProjectService,
        WarehouseService,
        WarehouseParamsFormService,
        LiningAndCoveringService
    ],
    entryComponents: [
        Warehouse1ParamsFormComponent,
        Warehouse2ParamsFormComponent,
        Warehouse3ParamsFormComponent,
        Warehouse4ParamsFormComponent,
        Warehouse5ParamsFormComponent,
        Warehouse6ParamsFormComponent,
        Warehouse1ProfilesFormComponent,
        Warehouse2ProfilesFormComponent,
        Warehouse3ProfilesFormComponent,
        Warehouse4ProfilesFormComponent,
        Warehouse5ProfilesFormComponent,
        Warehouse6ProfilesFormComponent,
    ]
})
export class ProjectModule {
}



// WEBPACK FOOTER //
// ./src/app/project/project.module.ts